var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxGlobeAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 27.4035V29.1666H13.125V32.0833H21.875V29.1666H18.9583V26.476C20.6288 25.7533 22.1482 24.7223 23.4369 23.4369C29.1214 17.7523 29.1214 8.49915 23.4369 2.81165L21.3748 4.87373C25.9233 9.42373 25.9233 16.8248 21.3748 21.3733C16.8262 25.9204 9.42373 25.9233 4.87519 21.3733L2.81311 23.4354C4.16649 24.7901 5.77413 25.8642 7.54373 26.596C9.31334 27.3278 11.2101 27.7028 13.125 27.6996C14.1047 27.6993 15.0819 27.6001 16.0417 27.4035Z",
    fill: "#FF4A23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 13.125C4.375 17.9506 8.29938 21.875 13.125 21.875C17.9506 21.875 21.875 17.9506 21.875 13.125C21.875 8.29938 17.9506 4.375 13.125 4.375C8.29938 4.375 4.375 8.29938 4.375 13.125ZM18.9583 13.125C18.9583 16.3421 16.3421 18.9583 13.125 18.9583C9.90792 18.9583 7.29167 16.3421 7.29167 13.125C7.29167 9.90792 9.90792 7.29167 13.125 7.29167C16.3421 7.29167 18.9583 9.90792 18.9583 13.125Z",
    fill: "#FF4A23"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxGlobeAlt);
export default __webpack_public_path__ + "static/media/bx_globe-alt.0547f6ee85d70d66b2d30bd77139dcc0.svg";
export { ForwardRef as ReactComponent };